import { Injectable } from '@angular/core';
import { EntityStore, StoreConfig } from '@datorama/akita';

import { ApprovalState, createInitialState } from './approval.model';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'approval' })
export class ApprovalStore extends EntityStore<ApprovalState> {
  constructor() {
    super(createInitialState());
  }
}
